import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    minWidth: 0,
  },
  iconBox: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    border: '1px solid var(--primary)',
    borderRadius: 2,
    bgcolor: 'primary.light',
    placeSelf: 'start',
    '& svg': { fontSize: 22 },
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  titleRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  titleText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  secondaryRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    color: 'text.secondary',
    flexWrap: 'wrap',
    px: 0.5,
    typography: 'body2',
    minWidth: 0,
    '& > span': {
      mx: 0.75,
      color: 'text.disabled',
    },
    '& > :not(:first-of-type)::before': {
      content: '"|"',
      margin: '0 4px',
      color: 'text.secondary',
    },
  },
  secondaryItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.75,
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '& svg': { fontSize: '1rem' },
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    ml: 'auto',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
    flexShrink: 0,
  },
  mobileBackButton: {
    display: { xs: 'inline-flex', sm: 'none' },
    alignSelf: 'flex-start',
    ml: -1,
  },
  actions: {
    display: 'inline-flex',
    gap: 1,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
};
